import { create } from 'zustand';
import { clientBookingsApi } from '../api/clientBookingsApi';
import type { ClientBooking } from '../types/client';
import { ACTIVE_BOOKING_STATUSES } from '../types/client';

interface UpcomingBookingState {
  upcoming: ClientBooking | null;
  isLoading: boolean;
  error: string | null;
  refresh: () => Promise<void>;
}

export const useUpcomingBookingStore = create<UpcomingBookingState>((set) => ({
  upcoming: null,
  isLoading: false,
  error: null,

  refresh: async () => {
    set({ isLoading: true, error: null });
    try {
      const bookings = await clientBookingsApi.getList();
      const active = bookings
        .filter((b) => (ACTIVE_BOOKING_STATUSES as readonly string[]).includes(b.status))
        .sort((a, b) => new Date(a.startTime).getTime() - new Date(b.startTime).getTime());
      set({ upcoming: active[0] ?? null, isLoading: false });
    } catch {
      set({ error: "Bronni yuklashda xatolik", isLoading: false });
    }
  },
}));
